import { injectable, inject } from 'inversify';
import { MultipartUploadStrategy, UploadDispatcher, MultipartUploadAdapter } from '@dealroadshow/file-uploader';
import DITypes from './DI/types';
import type { IUploadDispatcherFactory, ISocketProcessingAdapter } from './DI/interfaces';

@injectable()
export default class UploadDispatcherFactory implements IUploadDispatcherFactory {
  constructor(
    @inject(DITypes.SocketProcessingAdapter) private readonly processingAdapter: ISocketProcessingAdapter,
    @inject(DITypes.UploadAdapter) private readonly uploadAdapter: MultipartUploadAdapter,
  ) {}

  create() {
    return new UploadDispatcher(new MultipartUploadStrategy(this.uploadAdapter, this.processingAdapter));
  }
}
